import { Fragment } from 'react';

const AppFooter = () => {
  return (
    <Fragment>
      <div className="app-wrapper-footer">
        <div className="app-footer">
          <div className="app-footer__inner">
            <div className="app-footer-left">
              <span className="small text-muted">
                Orbit · Operator Cockpit
              </span>
            </div>
            <div className="app-footer-right">
              <span className="small text-muted">
                © Valitype
              </span>
            </div>
          </div>
        </div>
      </div>
    </Fragment>
  );
};

export default AppFooter;
